import { useEffect, useState } from "react";
import { TextField } from "@mui/material";
import InputLabel from "@mui/material/InputLabel";

export default function BillToForm({ billToFormRef }) {
  const [formData, setFormData] = useState({});
  const errors = {};
  useEffect(() => {
    if (billToFormRef?.current) {
      setFormData(billToFormRef.current);
    }
  }, [billToFormRef]);


  function correctSpaceFormat(value) {
    // Replace any non-standard whitespace characters with regular spaces
    return value.replace(/\s+/g, ' ');
}

  const handleChangeData = (event) => {
    const { name, value } = event.target;
    //let newValue = correctSpaceFormat(value.toString().toUpperCase()); // Convert value to uppercase 
    let newValue = correctSpaceFormat((value ?? "").toString().toUpperCase());
    // Validate the length based on the field name
    const maxCharacterLength = {
      //code: 5,
      code:25,
      location:25,
      status:25,
      COD:25,
      name: 25,
      address: 25,
      city: 25,
      state: 2,
      zip: 10,
      phone: 13,
      fax: 13,
      internalNote: 75,
      notes1: 25,
      notes2: 25,
      notes3: 25,
    };

    if (newValue.length > maxCharacterLength[name]) {
      newValue = newValue.slice(0, maxCharacterLength[name]); // Truncate the value if it exceeds the limit
    }

    // Update the state with the validated value
    setFormData({
      ...formData,
      [name]: newValue,
    });
    // Update the ref with the validated value
    billToFormRef.current = {
      ...billToFormRef.current,
      [name]: newValue,
    };
  };
 

  return (
    <>
      <form style={{ margin: "10px" }}>
     
      <div style={{ display: "flex", flexDirection: "row", marginBottom: "10px", width:"85%" }}>
    
    <div style={{ flex: 3, marginRight: "10px" }}>
        <InputLabel
            htmlFor="code"
            style={{
                color: "black",
                // marginBottom: "5px",
                fontSize: "0.85rem",
            }}
        >
           Bill To #
        </InputLabel>
        <TextField
            id="code"
            name="code"
value={(formData?.code ?? "").toString().toUpperCase()}
            onChange={handleChangeData}
            margin="none"
            fullWidth
            variant="outlined"
            size="small"
            InputLabelProps={{ style: { color: "black" } }}
            disabled={errors.code}
        />
    </div>
    <div style={{ flex: 3, marginRight: "10px" }}>
        <InputLabel
            htmlFor="status"
            style={{
                color: "black",
                // marginBottom: "5px",
                fontSize: "0.85rem",
            }}
        >
           Status
        </InputLabel>
        <TextField
            id="status"
            name="status"
            value={(formData?.status ?? "").toString().toUpperCase()}
            onChange={handleChangeData}
            margin="none"
            fullWidth
            variant="outlined"
            size="small"
            InputLabelProps={{ style: { color: "black" } }}
            disabled={errors.status}
        />
    </div>
    <div style={{ flex: 2 }}>
        <InputLabel
            htmlFor="COD"
            style={{
                color: "black",
                // marginBottom: "5px",
                fontSize: "0.85rem",
            }}
        >
            COD
        </InputLabel>
    
       
        <TextField
          id="COD"
          name="COD"
          value={(formData?.COD ?? "").toString().toUpperCase()}
          onChange={handleChangeData}
          margin="none"
          fullWidth
          variant="outlined"
          size="small"
          InputLabelProps={{ style: { color: "black" } }}
          disabled={errors.COD}
         
          InputProps={{
            style: {
              backgroundColor:formData.COD?"red":"",
                color: formData.COD ? "white" : "",
            },
        }}
        />
    </div>

        </div>

        {/* Credit Section */}
        <div style={{ display: "flex", flexDirection: "row", marginBottom: "10px" }}>

          <div style={{ flex: 3, marginRight: "10px" }}>
            <InputLabel
              htmlFor="creditLimit"
              style={{ color: "black", fontSize: "0.85rem" }}
            >
              Credit Limit
            </InputLabel>
            <TextField
              id="creditLimit"
              name="creditLimit"
              value={formData.creditLimit || ""}
              margin="none"
              fullWidth
              variant="outlined"
              size="small"
              disabled
            />
          </div>

          <div style={{ flex: 3, marginRight: "10px" }}>
            <InputLabel
              htmlFor="outstandingBalance"
              style={{ color: "black", fontSize: "0.85rem" }}
            >
              Outstanding Balance
            </InputLabel>
            <TextField
              id="outstandingBalance"
              name="outstandingBalance"
              value={formData.outstandingBalance || ""}
              margin="none"
              fullWidth
              variant="outlined"
              size="small"
              disabled
              InputProps={{
                style: {
                  backgroundColor:
                    Number(formData.outstandingBalance) >
                      Number(formData.creditLimit)
                      ? "#ffcccc"
                      : "",
                  color:
                    Number(formData.outstandingBalance) >
                      Number(formData.creditLimit)
                      ? "red"
                      : ""
                }
              }}
            />
          </div>

          <div style={{ flex: 3 }}>
            <InputLabel
              htmlFor="collectionsClerk"
              style={{ color: "black", fontSize: "0.85rem" }}
            >
              Collections Clerk
            </InputLabel>
            <TextField
              id="collectionsClerk"
              name="collectionsClerk"
              value={formData.collectionsClerk || ""}
              margin="none"
              fullWidth
              variant="outlined"
              size="small"
              disabled
            />
          </div>

        </div>
        <InputLabel
          htmlFor="name"
          style={{
            color: "black",
            marginTop: "10px",
            fontSize: "0.85rem",
          }}
        >
          Name
        </InputLabel>
        <TextField
          id="name"
          name="name"
          value={(formData?.name ?? "").toString().toUpperCase()}
          onChange={handleChangeData}
          margin="none"
          fullWidth
          variant="outlined"
          size="small"
          InputLabelProps={{ style: { color: "black" } }}
          disabled={errors.name}
        />
      
        <InputLabel
          htmlFor="addressLine1"
          style={{
            color: "black",
            marginTop: "10px",
            fontSize: "0.85rem",
          }}
        >
          Address Line 1
        </InputLabel>
        <TextField
          id="addressLine1"
          name="addressLine1"   
          value={(formData?.addressLine1 ?? "").toString().toUpperCase()}     
          onChange={handleChangeData}
          margin="none"
          fullWidth
          variant="outlined"
          size="small"
          InputLabelProps={{ style: { color: "black" } }}
          disabled={errors.addressLine1}
        />

        <InputLabel
          htmlFor="addressLine2"
          style={{
            color: "black",
            marginTop: "10px",
            fontSize: "0.85rem",
          }}
        >
          Address Line 2
        </InputLabel>
        <TextField
          id="addressLine2"
          name="addressLine2"   
          value={(formData?.addressLine2 ?? "").toString().toUpperCase()}     
          onChange={handleChangeData}
          margin="none"
          fullWidth
          variant="outlined"
          size="small"
          InputLabelProps={{ style: { color: "black" } }}
          disabled={errors.addressLine2}
        />

        <InputLabel
          htmlFor="city"
          style={{
            color: "black",
            marginTop: "10px",
            fontSize: "0.85rem",
          }}
        >
          City
        </InputLabel>
        <TextField
          id="city"
          name="city"
          value={(formData?.city ?? "").toString().toUpperCase()}    
          onChange={handleChangeData}
          margin="none"
          fullWidth
          variant="outlined"
          size="small"
          InputLabelProps={{ style: { color: "black" } }}
          disabled={errors.city}
        />

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            marginBottom: "10px",
          }}
        >
          <div style={{ flex: 1, marginRight: "10px" }}>
            <InputLabel
              htmlFor="state"
              style={{
                color: "black",
                marginTop: "10px",
                fontSize: "0.85rem",
              }}
            >
              State
            </InputLabel>
            <TextField
              id="state"
              //   label="State"
              name="state"
              value={(formData?.state ?? "").toString().toUpperCase()}   
              onChange={handleChangeData}
              margin="none"
              fullWidth
              variant="outlined"
              size="small"
              InputLabelProps={{ style: { color: "black" } }}
              disabled={errors.state}
            />
          </div>
          <div style={{ flex: 1 }}>
            <InputLabel
              htmlFor="countryCode"
              style={{
                color: "black",
                marginTop: "10px",
                fontSize: "0.85rem",
              }}
            >
              Country Code
            </InputLabel>
            <TextField
              id="countryCode"
              name="countryCode"
              value={formData.countryCode|| ""}
              onChange={handleChangeData}
              margin="none"
              fullWidth
              variant="outlined"
              size="small"
              InputLabelProps={{ style: { color: "black" } }}
              disabled={errors.countryCode}
            />
          </div>
          <div style={{ flex: 1, marginLeft: "10px" }}>
            <InputLabel
              htmlFor="zip"
              style={{
                color: "black",
                marginTop: "10px",
                fontSize: "0.85rem",
              }}
            >
              Zip Code
            </InputLabel>
            <TextField
              id="zip"
              name="zip"
              value={formData.zip|| ""}
              onChange={handleChangeData}
              margin="none"
              fullWidth
              variant="outlined"
              size="small"
              InputLabelProps={{ style: { color: "black" } }}
              disabled={errors.zip}
            />
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            marginBottom: "10px",
          }}
        >
          <div style={{ flex: 1, marginRight: "10px" }}>
            <InputLabel
              htmlFor="phone"
              style={{
                color: "black",
                marginTop: "10px",
                fontSize: "0.85rem",
              }}
            >
             Phone
            </InputLabel>
            <TextField
              id="phone"
              //   label="State"
              name="phone"
              value={(formData?.phone ?? "").toString().toUpperCase()}   
              onChange={handleChangeData}
              margin="none"
              fullWidth
              variant="outlined"
              size="small"
              InputLabelProps={{ style: { color: "black" } }}
              disabled={errors.phone}
            />
          </div>
          <div style={{ flex: 1, marginLeft: "10px" }}>
            <InputLabel
              htmlFor="fax"
              style={{
                color: "black",
                marginTop: "10px",
                fontSize: "0.85rem",
              }}
            >
             Fax
            </InputLabel>
            <TextField
              id="fax"
              name="fax"
              value={formData.fax|| ""}
              onChange={handleChangeData}
              margin="none"
              fullWidth
              variant="outlined"
              size="small"
              InputLabelProps={{ style: { color: "black" } }}
              disabled={errors.fax}
            />
          </div>
        </div>

        <InputLabel
          htmlFor="internalNote"
          style={{
            color: "black",
            marginTop: "10px",
            fontSize: "0.85rem",
          }}
        >
          Internal Note
        </InputLabel>
        <TextField
          id="internalNote"
          name="internalNote"
          value={formData.internalNote|| ""}
          onChange={handleChangeData}
          margin="none"
          fullWidth
          multiline
          rows={4}
          variant="outlined"
          size="small"
          InputLabelProps={{ style: { color: "black" } }}
          disabled={errors.internalNote}
        />
      </form>
    </>
  );
}
